import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import api from "../../services/api";
export const PAGE_SIZE = 20;
export default function usePromptList(companyId, socket) {
  const [prompts, setPrompts] = useState([]), [count, setCount] = useState(0);
  const [page, setPage] = useState(1), [search, setSearch] = useState("");
  const [query, setQuery] = useState(""), [revision, setRevision] = useState(0);
  const [loading, setLoading] = useState(true), [error, setError] = useState(false);
  const sequence = useRef(0);
  const refresh = useCallback(() => setRevision(value => value + 1), []);
  useEffect(() => { const timer = setTimeout(() => { setPage(1); setQuery(search.trim()); }, 250); return () => clearTimeout(timer); }, [search]);
  useEffect(() => {
    const request = ++sequence.current, cancel = axios.CancelToken.source();
    setLoading(true); setError(false);
    api.get("/prompt", { params: { searchParam: query, pageNumber: page }, timeout: 20000, cancelToken: cancel.token })
      .then(({ data }) => {
        if (request !== sequence.current) return;
        const total = Number(data.count) || 0;
        if (page > Math.max(1, Math.ceil(total / PAGE_SIZE))) { setPage(Math.max(1, Math.ceil(total / PAGE_SIZE))); return; }
        setPrompts(Array.isArray(data.prompts) ? data.prompts : []); setCount(total);
      })
      .catch(err => { if (request === sequence.current && !axios.isCancel(err)) setError(true); })
      .finally(() => { if (request === sequence.current) setLoading(false); });
    return () => { sequence.current += 1; cancel.cancel(); };
  }, [companyId, page, query, revision]);
  useEffect(() => {
    if (!socket || !companyId) return undefined;
    let timer;
    const changed = data => { if (["create", "update", "delete"].includes(data?.action) && !timer) timer = setTimeout(() => { timer = null; refresh(); }, 350); };
    const event = "company-" + companyId + "-prompt"; socket.on(event, changed);
    return () => { clearTimeout(timer); socket.off(event, changed); };
  }, [companyId, socket, refresh]);
  return { prompts, count, page, setPage, search, setSearch, loading, error, refresh };
}
